import { DtoInclude, DtoIncludeNumber, DtoRefList } from '../../../core/store/dto/dto';
import { Control } from '../control/control.model';
import { RestrictedAccountObjectDto } from '../restricted-account-object/restricted-account-object.dto';

export class GroupDto extends RestrictedAccountObjectDto {
    @DtoInclude
    name: string;
    @DtoInclude
    title: string;
    @DtoIncludeNumber
    sequence: number;
    @DtoIncludeNumber
    scoreWeight: number;
    @DtoInclude
    includeInSummary: boolean;

    controls: Array<string> | Array<Control>;
    @DtoRefList
    forms: Array<string>;

    @DtoInclude
    visibilityControl;

    @DtoInclude
    visibleIfEquals;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/group/group.dto.ts